// extracted by mini-css-extract-plugin
module.exports = {"livestock-main-wrapper":"LiveStock_livestock-main-wrapper__1ok0z"};